"use strict";
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FetchGraphqlError = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _logger = require("@ori/logger");
/**
 * The `trimString` function takes a GraphQL query as input and returns a trimmed version of it if its
 * length exceeds 255 characters.
 * @param {string} graphqlQuery - The `trimString` function takes a `graphqlQuery` parameter, which is
 * expected to be a string. The function checks if the length of the `graphqlQuery` is greater than 255
 * characters. If it is, the function returns the first 255 characters of the `graphqlQuery`, otherwise
 * @returns If the length of the `graphqlQuery` is greater than 255 characters, the function will
 * return the first 255 characters of the `graphqlQuery`. Otherwise, it will return the original
 * `graphqlQuery` unchanged.
 */ var trimGraphqlQuery = function(graphqlQuery) {
    if (graphqlQuery.length > 255) {
        return graphqlQuery.slice(0, 255);
    }
    return graphqlQuery;
};
/**
 * Generic error caused by failed fetch to the graphql server
 */ var FetchGraphqlError = /*#__PURE__*/ function(_logger_FormattedAxiosError) {
    _inherits(FetchGraphqlError, _logger_FormattedAxiosError);
    function FetchGraphqlError(axiosError, graphqlQuery) {
        _class_call_check(this, FetchGraphqlError);
        var _this;
        _this = _call_super(this, FetchGraphqlError, [
            axiosError
        ]);
        (0, _defineProperty2.default)(_this, "variables", void 0);
        (0, _defineProperty2.default)(_this, "graphqlQuery", void 0);
        _this.name = 'FetchGraphqlError';
        var config = axiosError.config;
        _this.variables = _type_of(config === null || config === void 0 ? void 0 : config.data) === 'object' && 'variables' in config.data ? config.data.variables : null;
        _this.graphqlQuery = trimGraphqlQuery(graphqlQuery);
        return _this;
    }
    return FetchGraphqlError;
}(_logger.FormattedAxiosError);
exports.FetchGraphqlError = FetchGraphqlError; //# sourceMappingURL=FetchGraphqlError.js.map
